import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { v2 } from "../ui/v2Tokens";
import V2Dialog from "../ui/V2Dialog";
import { PrimaryButton, TextButton } from "../ui/primitives";

type Props = {
  open: boolean;
  onClose: () => void;
  defaultName: string;
  mealCount: number;
  onSave: (name: string) => void;
};

/** Saves a whole menu to the company template library, so new menus can start from it. */
const SaveMenuAsTemplateDialog = ({ open, onClose, defaultName, mealCount, onSave }: Props) => {
  const [name, setName] = useState(defaultName);

  // the dialog is reused across rows — follow whichever menu opened it
  useEffect(() => {
    if (open) setName(defaultName);
  }, [open, defaultName]);

  return (
    <V2Dialog
      open={open}
      onClose={onClose}
      title="שמור תפריט כתבנית"
      subtitle="התבנית תהיה זמינה לכל המאמנים בחברה כנקודת פתיחה לתפריט חדש"
      maxWidth="420px"
      actions={
        <>
          <TextButton onClick={onClose}>ביטול</TextButton>
          <PrimaryButton disabled={!name.trim() || mealCount === 0} onClick={() => onSave(name.trim())}>
            שמור תבנית
          </PrimaryButton>
        </>
      }
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Box
          component="input"
          type="text"
          aria-label="שם התבנית"
          placeholder="שם התבנית"
          value={name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
          sx={{
            height: "38px",
            padding: "0 10px",
            borderRadius: v2.rSm,
            border: `1.5px solid ${v2.line}`,
            fontSize: "13px",
            fontFamily: "inherit",
            color: v2.ink,
            outline: "none",
            "&:focus": { borderColor: v2.brand },
          }}
        />
        <Box sx={{ fontSize: "12px", color: mealCount === 0 ? v2.over : v2.ink2 }}>
          {mealCount === 0
            ? "התפריט ריק — אין ארוחות לשמור בתבנית."
            : `${mealCount} ארוחות יישמרו בתבנית.`}
        </Box>
      </Box>
    </V2Dialog>
  );
};

export default SaveMenuAsTemplateDialog;
